import { jwtDecode } from "jwt-decode";

const TEN_MINUTES = 600000;

export function getIsExpiredToken(token: string | null | undefined) {
  try {
    if (!token) return true;
    const cleanToken = token.replace("Bearer ", "");
    const parsedToken = jwtDecode(cleanToken);

    return (
      !parsedToken ||
      (parsedToken as any).expiresAt === 0 ||
      (parsedToken as any).expiresAt - Date.now() <= TEN_MINUTES
    );
  } catch (e) {
    console.error("Token parsing error:", e);
    return true;
  }
}

export function getCanTokenExpiredAt(token: string) {
  const parsedToken = jwtDecode(token);
  return parsedToken && typeof parsedToken !== "string"
    ? (parsedToken as any).expiresAt
    : undefined;
}
export function getIsExpiredCanToken(token: string) {
  const expiredAt = getCanTokenExpiredAt(token.replace("Bearer ", ""));
  return expiredAt ? expiredAt - Date.now() <= TEN_MINUTES : true;
}
